import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionLink", "cancelRecipientForm"]

  submit() {
    if (this.hasCancelRecipientFormTarget == false) {
      console.error("Tried to cancel a recipient but form wasn't found")
      return
    }

    this.actionLinkTarget.removeAttribute("data-action")
    this.actionLinkTarget.innerHTML = `<div class='far fa-spinner-third fa-spin'></div>&nbsp;${i18n.t("js.back.campaigns.cancel.canceling")}`
    this.cancelRecipientFormTarget.submit()
  }
}
